export const DEVICE_STATUS_TOPIC = '/visualization/device-status'
const identifier = /^[A-Za-z0-9_-]{1,64}$/
const countKeys = ['total', 'online', 'offline', 'notActive', 'unknown', 'active']

function invalid (message, code) {
  const error = new Error(message)
  error.code = code
  return error
}

export function deviceStatusProductIds (option = {}) {
  const ids = option.productIds === undefined ? [option.productId] : option.productIds
  if (!Array.isArray(ids) || !ids.length || ids.length > 100 || ids.some(id => typeof id !== 'string' || !identifier.test(id))) throw invalid('请至少选择一个有效产品，最多100个', 'DEVICE_STATUS_QUERY_INVALID')
  return [...new Set(ids)].sort()
}

export function deviceStatusQuery (option = {}, context = {}, editing = false) {
  if (!option || typeof option !== 'object' || Array.isArray(option)) throw invalid('设备统计范围无效', 'DEVICE_STATUS_QUERY_INVALID')
  const scope = option.productScope === undefined ? 'all' : option.productScope
  if (!['all', 'specified', 'page'].includes(scope)) throw invalid('设备统计范围无效', 'DEVICE_STATUS_QUERY_INVALID')
  if (scope === 'all') return { scope: 'all' }
  if (scope === 'specified') {
    const productIds = deviceStatusProductIds(option)
    return productIds.length === 1 ? { scope: 'product', productId: productIds[0] } : { scope: 'products', productIds }
  }
  // 示例产品只用于编辑画布，运行和编辑器预览必须遵循实际传入的产品上下文。
  const productId = scope === 'specified' ? option.productId : editing ? option.previewProductId : context && context.productId
  if (typeof productId !== 'string' || !identifier.test(productId)) {
    throw invalid(scope === 'page' ? (editing ? '请选择编辑时使用的示例产品' : '当前页面没有有效产品 ID，请从产品列表进入') : '请选择有效产品', 'DEVICE_STATUS_QUERY_INVALID')
  }
  return { scope: 'product', productId }
}

export function deviceStatusSnapshot (frame) {
  const reject = () => { throw invalid('设备在线统计快照无效，请重新获取', 'DEVICE_STATUS_SNAPSHOT_INVALID') }
  if (!frame || typeof frame !== 'object' || Array.isArray(frame) || frame.kind !== 'snapshot') reject()
  if (countKeys.some(key => !Number.isSafeInteger(frame[key]) || frame[key] < 0)) reject()
  if (!Number.isSafeInteger(frame.revision) || frame.revision < 0) reject()
  const active = frame.online + frame.offline
  const total = active + frame.notActive + frame.unknown
  if (!Number.isSafeInteger(total) || frame.active !== active || frame.total !== total) reject()
  const onlineRate = active ? frame.online / active * 100 : 0
  // 后端允许将百分比保留两位小数，但不能把未激活/未知设备算作离线。
  if (!Number.isFinite(frame.onlineRate) || frame.onlineRate < 0 || frame.onlineRate > 100 || Math.abs(frame.onlineRate - onlineRate) > 0.011) reject()
  return { kind: 'snapshot', total, online: frame.online, offline: frame.offline,
    notActive: frame.notActive, unknown: frame.unknown, active, onlineRate, revision: frame.revision }
}
